import React from "react";
import moment from "moment-timezone";
import DateRangePicker from "components/common/DateRangePicker";
import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import LoadingUI from "components/common/LoadingUI";
import { CrossCheckSheetAPI } from "apis";
import { MESSAGE } from "constants/Message";
import { DATE_RANGE_TYPE } from "components/playground/home-dashboard-v2/DateHelper";
import { ROLE } from "./CrossCheckHelper";

class RefreshModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: [],
      isSaving: false,
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),

      refreshInterval: null,
      refreshStatus: null,
      operationId: null,
    };

    this.handleDateRangeFilterChanged =
      this.handleDateRangeFilterChanged.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  componentWillUnmount() {
    if (this.state.refreshInterval) {
      clearInterval(this.state.refreshInterval);
    }
    this.setState({ refreshInterval: null });
  }

  handleClosePopover() {
    this.child.current.handleClosePopup();
  }

  handleDateRangeFilterChanged({ startDate, endDate }) {
    this.setState({
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
    });
  }

  async handleRefresh() {
    const { startDate, endDate } = this.state;
    const { networkId, sheetId, role, instanceId } = this.props;

    const dateRange = moment(endDate).diff(moment(startDate), "days");
    if (dateRange > 90) {
      this.setState({
        msg: ["Date range cannot be more than 90 days", MESSAGE.ERROR],
      });
      return;
    }

    this.setState({ isSaving: true, msg: [] });

    try {
      let operationId = null;
      if (role === ROLE.CCS) {
        const { operation_id } =
          await CrossCheckSheetAPI.refreshCrossCheckSheet({
            networkId,
            startDate,
            endDate,
            sheetId,
          });
        operationId = operation_id;
      } else if (role === ROLE.INSTANCE && sheetId && instanceId) {
        const { operation_id } = await CrossCheckSheetAPI.refreshCcsInstance({
          networkId,
          startDate,
          endDate,
          sheetId,
          instanceId,
        });
        operationId = operation_id;
      }

      if (operationId) {
        this.handleTrack(operationId);

        this.setState({
          isSaving: false,
          operationId,
          msg: [
            `${role} is refreshing. \n Keep this modal open to track progress, or refresh the page after closing to check status.`,
            MESSAGE.SUCCESS,
          ],
          refreshStatus: "INITIALIZING",
          refreshInterval: setInterval(() => {
            this.handleTrack(operationId);
          }, 10000),
        });
      }
    } catch (err) {
      this.setState({
        isSaving: false,
        msg: [
          err.message || `Failed to refresh ${role.toLowerCase()}.`,
          MESSAGE.ERROR,
        ],
      });
    }
  }

  async handleTrack(operationId) {
    const { status, reason } = await CrossCheckSheetAPI.getOperationStatus({
      operationId,
    });

    if (status) {
      this.setState({
        refreshStatus: status,
      });

      if (status === "SUCCESS" || status === "FAILED") {
        if (this.state.refreshInterval) {
          clearInterval(this.state.refreshInterval);
        }
        this.setState({
          refreshInterval: null,
          msg:
            status === "SUCCESS"
              ? ["Refreshed successfully", MESSAGE.SUCCESS]
              : [reason || "Failed to refresh", MESSAGE.ERROR],
        });
      }
    }
  }

  render() {
    const { handleClose, role } = this.props;

    const { startDate, endDate, msg, isSaving, refreshStatus, operationId } =
      this.state;
    return (
      <ModalWrapper
        isOpen={true}
        title={`Refresh ${role}`}
        showCloseFooter={false}
        customOverlayStyle={{ zIndex: 100 }}
        width="35%"
      >
        <div className="mb-6">
          {operationId ? (
            <div className="rounded flex flex-col items-center justify-center bg-gray-100 p-2">
              <div>
                <div className="flex gap-2">
                  <div className="w-24 text-right">Date Range:</div>
                  <span className="font-semibold text-blue-600">
                    {startDate} to {endDate}
                  </span>
                </div>
                <div className="flex gap-2">
                  <div className="w-24 text-right">Status:</div>
                  <span className="font-semibold text-blue-600">
                    {refreshStatus}
                  </span>
                </div>
              </div>

              {refreshStatus !== "SUCCESS" && (
                <LoadingUI iconOnly={true}></LoadingUI>
              )}
            </div>
          ) : (
            <>
              <div className="text-gray-600">Date Range</div>
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                months={1}
                place="right center"
                dateRanges={[
                  DATE_RANGE_TYPE.THIS_WEEK,
                  DATE_RANGE_TYPE.THIS_MONTH,
                  DATE_RANGE_TYPE.LAST_MONTH,
                ]}
                handleDateRangeChanged={this.handleDateRangeFilterChanged}
              ></DateRangePicker>
            </>
          )}
        </div>

        <ModalFooter
          msg={msg}
          isLoading={isSaving}
          onClose={handleClose}
          onCancel={handleClose}
          onConfirm={this.handleRefresh}
        ></ModalFooter>
      </ModalWrapper>
    );
  }
}

export default RefreshModal;
